import { z } from 'zod';

export const availabilityLeadQuerySchema = z.object({
  // Pagination
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).optional(),

  // Prioritize human review data for confirmed status
  prioritize_hr: z.coerce.boolean().optional(),

  // Slim response: only phone_number, executed_at, direction, availability_slots
  slim: z.coerce.boolean().optional(),

  // Relationship filters
  campaign_id: z.string().uuid().optional(),

  // Date range filter for executed_at
  executedAtFrom: z.coerce.date().optional(),
  executedAtTo: z.coerce.date().optional(),

  // Text search on phone_number
  search: z.string().optional(),

  // Sorting
  sortBy: z.enum(['executed_at', 'duration']).default('executed_at'),
  sortOrder: z.enum(['asc', 'desc']).default('desc'),
});

export type AvailabilityLeadQuery = z.infer<typeof availabilityLeadQuerySchema>;
